import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ClientSideEndpoints } from '../../../services/clientDetailService';

export const fetchProductListBasedOnCategory = createAsyncThunk(
    'product/fetchProductListBasedOnCategory',
    async (categoryId, { rejectWithValue }) => {
        try {
            const data = ClientSideEndpoints.getProductsBasedOnCategory(categoryId);
            return data;
        } catch (err) {
            return rejectWithValue(err.response?.data || 'Something went wrong');
        }
    }
);

export const fetchProductListBasedOnSubCategory = createAsyncThunk(
    'product/fetchProductListBasedOnSubCategory',
    async (subCategoryId, { rejectWithValue }) => {
        try {
            const data = ClientSideEndpoints.getProductsBasedOnSubCategory(subCategoryId);
            return data;
        } catch (err) {
            return rejectWithValue(err.response?.data || 'Something went wrong');
        }
    }
);
export const addToProductOrProjectToFavorites = createAsyncThunk(
    'product/addToProductOrProjectToFavorites',
    async (formData, { rejectWithValue }) => {
        try {
            const data = ClientSideEndpoints.addToProductOrProjectToFavorites(formData);
            return data;
        } catch (err) {
            return rejectWithValue(err.response?.data || 'Something went wrong');
        }
    }
);

export const removeProductOrProjectFromFavorites = createAsyncThunk(
    'product/removeProductOrProjectFromFavorites',
    async (itemId, { rejectWithValue }) => {
        try {
            const data = ClientSideEndpoints.removeProductOrProjectFromFavorites(itemId);
            return data;
        } catch (err) {
            return rejectWithValue(err.response?.data || 'Something went wrong');
        }
    }
);

export const addProductToCart = createAsyncThunk(
    'product/addProductToCart',
    async (formData, { rejectWithValue }) => {
        try {
            const data = ClientSideEndpoints.addProductToCart(formData);
            return data;
        } catch (err) {
            return rejectWithValue(err.response?.data || 'Something went wrong');
        }
    }
);

export const removeProductFromCart = createAsyncThunk(
    'product/removeProductFromCart',
    async (itemId, { rejectWithValue }) => {
        try {
            const data = ClientSideEndpoints.removeProductFromCart(itemId);
            return data;
        } catch (err) {
            return rejectWithValue(err.response?.data || 'Something went wrong');
        }
    }
);

export const fetchListOfProductsInCart = createAsyncThunk(
    'product/fetchListOfProductsInCart',
    async (_, { rejectWithValue }) => {
        try {
            const data = ClientSideEndpoints.fetchListOfProductsInCart();
            return data;
        } catch (err) {
            return rejectWithValue(err.response?.data || 'Something went wrong');
        }
    }
);

export const searchAndFilterProductItems = createAsyncThunk(
    'product/searchAndFilterProductItems',
    async (formData, { rejectWithValue }) => {
        try {
            const data = ClientSideEndpoints.searchAndFilterProductItems(formData);
            return data;
        } catch (err) {
            return rejectWithValue(err.response?.data || 'Something went wrong');
        }
    }
);

// fetchListOfFavorites
export  const fetchListOfFavorites = createAsyncThunk(
    'product/fetchListOfFavorites',
    async (_, { rejectWithValue }) => {
        try {
            const data = ClientSideEndpoints.fetchListOfFavorites();
            return data;
        } catch (err) {
            return rejectWithValue(err.response?.data || 'Something went wrong');
        }
    }
);


const clientCategorySlice = createSlice({
    name: 'productByCategory',
    initialState: {
        productsCategories: {},
        ListOfProductsDetail: [],
        cartProducts: [],
        ListOfFavorites: [],


        filteredProducts: null,
        loadingCategory: false,
        loadingFilteredProducts: false,
        loadingSubCategory: false,
        loadingFavorites: false,
        loadingCart: false,
        loadingListOfFavorites: false,

        errorCategory: null,
        errorSubCategory: null,
        errorFilteredProducts: null,
        errorFavorites: null,
        errorCart: null,
        errorListFavorites: null,

        listOfilesInCart: [],
        loadingForListOfFilesInCart: false,
        errorForListOfFilesInCart: null,

    },
    reducers: {
        clearFilteredProducts: (state) => {
            state.filteredProducts = null; 
        },
        removeDeletedFavItem: (state, action) => {
            const itemId = action.payload;
            state.ListOfFavorites = state.ListOfFavorites.filter((item) => item.id !== itemId);
        },
        removeDeletedCartItem: (state, action) => {
            const itemId = action.payload;
            state.listOfilesInCart = state.listOfilesInCart.filter((item) => item.id !== itemId);
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchProductListBasedOnCategory.pending, (state) => {
                state.loadingCategory = true;
                state.errorCategory = null;
            })
            .addCase(fetchProductListBasedOnCategory.fulfilled, (state, action) => {
                state.loadingCategory = false;
                state.productsCategories = action.payload;
            })
            .addCase(fetchProductListBasedOnCategory.rejected, (state, action) => {
                state.loadingCategory = false;
                state.errorCategory = action.payload || 'Failed to fetch categories';
            })

            .addCase(fetchProductListBasedOnSubCategory.pending, (state) => {
                state.loadingSubCategory = true;
                state.errorSubCategory = null;
            })
            .addCase(fetchProductListBasedOnSubCategory.fulfilled, (state, action) => {
                state.loadingSubCategory = false;
                state.ListOfProductsDetail = action.payload;
            })
            .addCase(fetchProductListBasedOnSubCategory.rejected, (state, action) => {
                state.loadingSubCategory = false;
                state.errorSubCategory = action.payload || 'Failed to fetch subcategories';
            })

            .addCase(addToProductOrProjectToFavorites.pending, (state) => {
                state.loadingFavorites = true;
                state.errorFavorites = null;
            })
            .addCase(addToProductOrProjectToFavorites.fulfilled, (state, action) => {
                state.loadingFavorites = false;
                state.ListOfProductsDetail = state.ListOfProductsDetail.map((item) => {

                    if (item.id === action.payload.id) {
                        return { ...item, is_favorite: true }; // Mark as fa vorite
                    }
                    return item;
                });
            })
            .addCase(addToProductOrProjectToFavorites.rejected, (state, action) => {
                state.loadingFavorites = false;
                state.errorFavorites = action.payload || 'Failed to add to favorites';

            })

            .addCase(removeProductOrProjectFromFavorites.pending, (state) => {
                state.loadingFavorites = true;
                state.errorFavorites = null;
            })
            .addCase(removeProductOrProjectFromFavorites.fulfilled, (state, action) => {
                state.loadingFavorites = false;
                state.ListOfProductsDetail = state.ListOfProductsDetail.map((item) => {
                    if (String(item.id) === String(action.payload.product_id)) {
                        return { ...item, is_favorite: false };
                    }
                    return item;
                });
            })
            .addCase(removeProductOrProjectFromFavorites.rejected, (state, action) => {
                state.loadingFavorites = false;
                state.errorFavorites = action.payload || 'Failed to remove from favorites';
            })
            .addCase(addProductToCart.pending, (state) => {
                state.loadingCart = true;
                state.errorCart = null;
            })
            .addCase(addProductToCart.fulfilled, (state, action) => {
                state.loadingCart = false;
                state.cartProducts.push(action.payload); 
                state.ListOfProductsDetail = state.ListOfProductsDetail.map((item) => {
                    if (String(item.id) === String(action.payload.id)) {
                        return { ...item, is_in_cart: true }; // Mark as in cart
                    }
                    return item;
                }
                );
            })
            .addCase(addProductToCart.rejected, (state, action) => {
                state.loadingCart = false;
                state.errorCart = action.payload || 'Failed to add product to cart';
            })

            .addCase(removeProductFromCart.pending, (state) => {
                state.loadingCart = true;
                state.errorCart = null;
            })
            .addCase(removeProductFromCart.fulfilled, (state, action) => {
                state.loadingCart = false;
                state.cartProducts = state.cartProducts.filter(
                    (product) => product.id !== action.payload.id // Remove the product from the cart
                );
                state.ListOfProductsDetail = state.ListOfProductsDetail.map((item) => {
                    if (String(item.id) === String(action.payload.product_id)) {
                        return { ...item, is_in_cart: false }; 
                    }
                    return item;
                });
            })
            .addCase(removeProductFromCart.rejected, (state, action) => {
                state.loadingCart = false;
                state.errorCart = action.payload || 'Failed to remove product from cart';
            })

            .addCase(fetchListOfProductsInCart.pending, (state) => {
                state.loadingCart = true;
                state.loadingForListOfFilesInCart = true;
                state.errorCart = null;
                state.errorForListOfFilesInCart = null;
            })
            .addCase(fetchListOfProductsInCart.fulfilled, (state, action) => {
                state.loadingCart = false;
                state.loadingForListOfFilesInCart = false;
                state.listOfilesInCart = action.payload; // Set the list of files in cart
                state.cartProducts = action.payload; // Set the cart products
            })
            .addCase(fetchListOfProductsInCart.rejected, (state, action) => {
                state.loadingCart = false;
                state.loadingForListOfFilesInCart = false;
                state.errorCart = action.payload || 'Failed to fetch cart products';
                state.errorForListOfFilesInCart = action.payload || 'Failed to fetch cart products';
            })

            
            .addCase(searchAndFilterProductItems.pending, (state) => {
                state.loadingFilteredProducts = true;
                state.errorFilteredProducts = null;
            })
            .addCase(searchAndFilterProductItems.fulfilled, (state, action) => {
                state.loadingFilteredProducts = false;
                state.filteredProducts = action.payload;
            })
            .addCase(searchAndFilterProductItems.rejected, (state, action) => {
                state.loadingFilteredProducts = false;
                state.errorFilteredProducts = action.payload || 'Failed to filter products';
            })
            // list of favorites
            .addCase(fetchListOfFavorites.pending, (state) => {
                state.loadingListOfFavorites = true;
                state.errorListFavorites = null;
            })
            .addCase(fetchListOfFavorites.fulfilled, (state, action) => {
                state.loadingListOfFavorites = false;
                state.ListOfFavorites = action.payload; 
            })
            .addCase(fetchListOfFavorites.rejected, (state, action) => {
                state.loadingListOfFavorites = false;
                state.errorListFavorites = action.payload || 'Failed to fetch cart products';
            })

    
    }
});

export const { clearFilteredProducts, removeDeletedFavItem, removeDeletedCartItem } = clientCategorySlice.actions;
export default clientCategorySlice.reducer;